// ContractForm.js
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { Form, Input, Button, DatePicker, Select, InputNumber, Modal, Card, Layout, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import Title from 'antd/lib/typography/Title';

import Sidebar from "../../Side_Bar/Admin_Side_Bar.js";

const { Option } = Select;

const ContractForm = () => {
  const location = useLocation();
  const [form] = Form.useForm();
  const [customerList, setCustomerList] = useState([]);
  const [tenureMonths, setTenureMonths] = useState(0);
  const [loading, setLoading] = useState(true);

  const mainUrl                         = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";

  const [isChangeOk, setIsChangeOk] = useState(false);
  const [isChangeNotOk, setIsChangeNotOk] = useState(false);
  const navigate = useNavigate();

  const fetchTableData = async () => {
    try {
      const response = await fetch(`${mainUrl}/getAllTable?tableName=Customer`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    } catch (error) {
      console.error('Error fetching table data:', error);
      throw error; // Re-throw the error for the calling function to handle
    }
  };
  

  // Simulated fetch of customer data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const customerList = await fetchTableData();

        const customers = customerList.map(customer => ({
          id: customer.customer_id,
          name: customer.name,
          // Add more properties as needed
        }));

        setCustomerList(customers);
      } catch (error) {
        // Handle error, e.g., show an error message to the user
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleValuesChange = (_, allValues) => {
    const startDate = allValues.start_date;
    const endDate = allValues.end_date;

    if (startDate && endDate) {
      const startDateTime = new Date(startDate.format('YYYY-MM-DD'));
      const endDateTime = new Date(endDate.format('YYYY-MM-DD'));

      // Calculate the difference in months
      const monthsDiff = (endDateTime.getFullYear() - startDateTime.getFullYear()) * 12 +
        (endDateTime.getMonth() - startDateTime.getMonth());

      setTenureMonths(monthsDiff);
      console.log(tenureMonths)
    }
  };
  
  const onFinish = (values) => {
    // Add logic to send the form data to the server or perform other actions
    const start_date_formatted = values.start_date.toISOString().split('T')[0];
    const end_date_formatted = values.end_date.toISOString().split('T')[0];


    const requestBody = {
      type: values.type,
      description: values.description,
      monthly_duration: tenureMonths,
      start_date: start_date_formatted,
      end_date: end_date_formatted,
      monthly_message_quota: values.message_quota,
      customer_id: values.customer_id,
      prepaid_amount: values.prepaid_amount,
      name: values.name
    };

    console.log(requestBody)

    const insertContractUrl = `${mainUrl}/insertContract`;
    
    fetch(insertContractUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Response from server:', data);
        setIsChangeOk(true);
      })
      .catch(error => {
        console.error('Error:', error);
        setIsChangeNotOk(true);
      });
    

    // Reset the form after submission
    form.resetFields();
  };

  const handleModalOk = () => {
    // Handle the OK button in the modal
    // For example, navigate to another page or perform additional actions
    setIsChangeOk(false);
    navigate('/view_edit_customer');
  };

  const handleModalNotOk = () => {
    // Handle the OK button in the modal
    // For example, navigate to another page or perform additional actions
    setIsChangeNotOk(false);
    navigate('/view_edit_customer');
  };

  const boxHeight = '50px';
  
  return (
    <Layout style={{ minHeight: '98vh' }}>
      <Sidebar location={location} />

      <Layout style={{ background: 'white'}}>
        <Title level={2} style={{marginTop: "0px", margin: "20px", fontWeight: "bold", textAlign: "left"}}>CREATE SUBSCRIPTION</Title>
          <div style={{ maxWidth: "100%", margin: '20px', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
              <Form
                form={form}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 16 }}
                onFinish={onFinish}
                initialValues={{ remember: true }}
                onValuesChange={handleValuesChange}
              >

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item 
                  name="customer_id" 
                  rules={[{ required: true, message: 'Please select a customer' }]}
                  style={{ fontSize: '16px', flex: '1'}}
                  >
                    {loading ? (
                      <Select placeholder="Loading..." style={{ height: boxHeight, width: "150%"}} disabled />
                    ) : (
                      <Select placeholder="Company Name" style={{ height: boxHeight, width: "150%"}}>
                        {customerList.map(customer => (
                          <Option key={customer.id} value={customer.id}>
                            {customer.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item name="name" 
                  rules={[{ required: true, message: 'Please enter the name' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                  >
                    <Input 
                    placeholder="Package Name"
                    style={{ height: boxHeight, width: "150%"}} />
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item 
                  name="type" 
                  rules={[{ required: true, message: 'Please enter the type' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                  >
                    <Select placeholder="Package Type" style={{ height: boxHeight, width: "150%"}}>
                      <Option value="Basic">Basic</Option>
                      <Option value="Advance">Advance</Option>
                      <Option value="Comprehensive">Comprehensive</Option>
                      <Option value="Custom">Custom</Option>
                    </Select>
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item 
                  name="description" 
                  rules={[{ required: true, message: 'Please enter the description' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                  >
                    <Input 
                    placeholder="Description"
                    style={{ height: boxHeight, width: "150%"}} />
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item 
                  name="message_quota" 
                  rules={[{ required: true, message: 'Please enter the message quota' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                  >
                    <InputNumber 
                    placeholder="Message Quota"
                    style={{ height: boxHeight, width: "150%"}} />
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item 
                  name="prepaid_amount" 
                  rules={[{ required: true, message: 'Please enter the prepaid amount' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                  >
                    <InputNumber 
                    placeholder ="Prepaid Amount (RM)"
                    style={{ height: boxHeight, width: "150%"}} />
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item
                    name="start_date"
                    rules={[{ required: true, message: 'Please select the tenure start date' }]}
                    style={{ fontSize: '16px', flex: '1' }}
                  >
                    <DatePicker 
                    placeholder="Tenure Start Date"
                    style={{ height: boxHeight, width: "140%", marginRight: "3%" }}/>
                  </Form.Item>

                  <Form.Item
                    name="end_date"
                    rules={[
                      { required: true, message: 'Please select the tenure end date' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const startDate = getFieldValue('start_date');

                          // Convert the dates to JavaScript Date objects
                          const startDateObject = new Date(startDate);
                          const endDateObject = new Date(value);

                          // Compare the dates
                          if (!value || startDateObject < endDateObject) {
                            // Calculate the difference in months
                            const monthsDiff = (endDateObject.getFullYear() - startDateObject.getFullYear()) * 12 +
                              (endDateObject.getMonth() - startDateObject.getMonth());

                            // Check the minimum and maximum difference
                            if (monthsDiff >= 6 && monthsDiff <= 36) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject('Tenure must be between 6 months and 3 years');
                            }
                          }

                          return Promise.reject('End date must be after the start date');
                        },
                      }),
                    ]}
                    style={{ fontSize: '16px', flex: '1' }}
                  >
                    <DatePicker 
                    placeholder="Tenure End Date"
                    style={{ height: boxHeight, width: "140%", marginRight: "3%" }} />
                  </Form.Item>

                  <Form.Item label="Tenure (Months)" name="remainingTenureMonths">
                    <span>{tenureMonths}</span>
                  </Form.Item>
                </div>

                <div style={{ flexWrap: 'wrap', position: 'fixed', right: 30}}>
                  <Form.Item>
                  <Button 
                  type="primary" htmlType="submit" 
                  style={{ height: boxHeight, background: "#00308F" }}>
                      CREATE
                  </Button>
                  </Form.Item>
                </div>
              </Form>

            <Modal
              title="Comapny Profile Created"
              visible={isChangeOk}
              onOk={handleModalOk}
              okText="OK"
              closable={false}
              cancelButtonProps={{ style: { display: 'none' } }}
              centered
            >
              {/* Additional content in the modal */}
            </Modal>

            <Modal
              title="Error Creating Company"
              visible={isChangeNotOk}
              onOk={handleModalNotOk}
              okText="OK"
              closable={false}
              cancelButtonProps={{ style: { display: 'none' } }}
              centered
            >
              {/* Additional content in the modal */}
            </Modal>

          </div>
      </Layout>
    </Layout>
  );
  
};

export default ContractForm;

